import React from "react";

const Logo = () => {
  return <img alt="" src="/images/Logo.png" width={110} height={77} />;
};

export default Logo;
